import { ReactComponent as ProfileIcon } from "@preownedfront/lib-reowds/icons/24/user.svg";
import { useHistory, useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "src/utils/constants";
import { getClassnames } from "src/utils/utils";
import { ProfileShorcutNotification } from "./ProfileShorcutNotification/ProfileShorcutNotification";

import { t } from "i18next";
import useCustomerNotification from "src/hooks/React_Query/Customer/v2/Notification/useCustomerNotification";
import useNotificationViewedMutation, { NOTIFICATION_TYPE } from "src/hooks/React_Query/Customer/v2/Notification/useNotificationViewedMutation";
import { useAppState } from "src/hooks/state/use-app-state";
import "./profile-shortcut.scss";

interface ProfileShortcutProps {
  className?: string;
  typeIcon?: "icon" | "text";
}

export const ProfileShortcut = ({ className, typeIcon = "icon" }: ProfileShortcutProps) => {
  const history = useHistory()
  const { pathname } = useLocation();
  const user = useAppState((state) => state?.profile?.user);

  const linkContainer = getClassnames({
    [className]: !!className,
  });
  
  const isProfileSection = pathname.includes(ROUTE_PATHS.PROFILE);
  const notification = useCustomerNotification(!!user?.logonId && !(history.location.pathname.includes(ROUTE_PATHS.CART) || history.location.pathname.includes(ROUTE_PATHS.CHECKOUT)));
  
  const iconNotificationViewed = useNotificationViewedMutation();

  const goToProfile = () => history.push(ROUTE_PATHS.PROFILE)

  const onProfileShortcutClick = async (): Promise<void> => {
    if(notification?.data?.data?.iconNotification){
      try {
        await iconNotificationViewed?.mutateAsync({notificationType: NOTIFICATION_TYPE.ICON_NOTIFICATION});
      } catch (error) {
        console.log("List could not be marked as viewed", error);
      } finally {
        goToProfile()
      }
    } else {
      goToProfile()
    }
  }

  const classNameNotification = getClassnames({
    ["profile-shorcut__notification--icon"]: typeIcon === "icon",
    ["profile-shorcut__notification--text"]: typeIcon === "text",
  })

  return (
    <button
          aria-label={t("profile_my_account")}      
          className={linkContainer} 
          onClick={() => void onProfileShortcutClick()}
    >
        {typeIcon === "icon" ? (
          <ProfileIcon className="nav__icons__wm-icon__svg profile-shortcut_icon" />
        ) : (
          <span className="zds-label-l">{t("profile_icon")}</span>
        )}
        <ProfileShorcutNotification
          show={(notification?.data?.data?.iconNotification && !isProfileSection)}
          className={classNameNotification}
        />
    </button>
  );
};
